/**
 * 时时彩，通用模板，待投注列表
 */
import { connect } from 'react-redux'
import Loader from '../../../components/icon/Loader.jsx';
import ChangeTimes from './ChangeTimes.jsx';
import SelectTimes from './SelectTimes.jsx';
import TimeBox from './TimeBox.jsx';
import { CANNOT_TRACK_LOTTERY } from '../../../constants/lotterys/config'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as Rules from '../../../constants/lotterys/rules/rulesEntry'

class OrderList extends React.Component {

  constructor(props) {
    super(props);
    this.makeCodes = this.makeCodes.bind(this);
    this.toggleDetail = this.toggleDetail.bind(this);
    this.removeBet = this.removeBet.bind(this);
    this.toggleStopWhenWin = this.toggleStopWhenWin.bind(this);
    this.handleChangePlayTimes = this.handleChangePlayTimes.bind(this);
    this.handleWinnerNotice = this.handleWinnerNotice.bind(this);
    this.handleChangeTimes = this.handleChangeTimes.bind(this);
    this.state = {
      showDetail: false,
    }
  }

  componentWillUnmount(){
    if (this.closeTimer) {window.clearTimeout(this.closeTimer)}
    if (this.countdownTimer) {window.clearTimeout(this.countdownTimer)}
  }
  componentWillReceiveProps(nextProps){
    const __methods = nextProps.__METHOD.toJS();
    const lotteryWindow = __methods.windows[nextProps.windowId];
    //倒计时
    this.countdown = lotteryWindow.current_issue.countdown
    this.interval = lotteryWindow.current_issue.interval




  }
 
  // 删除投注单
  removeBet(betId = null) {
    const { windowId } = this.props;
    this.props.$$LOTTERY.removeOrder(windowId, betId);
  }

  // 打开详情
  toggleDetail(id = null, status) {
    let detailId = null;
    if (this.state.detailId != id) {
      detailId = id;
    }
    this.setState({
      detailId: detailId,
      showDetail: status
    })
  }

  // 切换是否中奖后停止
  toggleStopWhenWin(status) {
    const { windowId } = this.props;
    this.props.$$LOTTERY.toggleStopWhenWin(windowId, !status)
  }

  // 变更连续开奖期数
  handleChangePlayTimes(number) {
    const { windowId } = this.props;
    this.props.$$LOTTERY.mmcPlayTimes(windowId, number);
  }

  // 切换中奖通知
  handleWinnerNotice() {
    const __base = this.props.__BASE.toJS();
    const { startWinnerNotice, stopWinnerNotice } = this.props.$$BASE;
    __base.config.winnerNotice ? stopWinnerNotice() : startWinnerNotice()
  }

  // 生成玩法与投注号码
  makeCodes(name, codes, id, mode) {
    let displayCodes = name + codes;
    // 正常长度
    if (displayCodes.length <= 30) {
      return <th><span> {displayCodes}</span></th>;
    }
    // 超长之后显示详情
    displayCodes = displayCodes.substr(0, 30) + '......';
    return <th>
      <span>{displayCodes}</span><a className='orange pointer' style={{witheSpace: 'nowrap'}} onClick={this.toggleDetail.bind(this, id, true)}>{this.state.showDetail && this.state.detailId == id?'收起':'详情'}</a>
      {
        this.state.showDetail && this.state.detailId == id
          ?
          <div className="more">
            <textarea className="code" readOnly='readOnly' defaultValue={codes}></textarea>
          </div>
          : ''
      }
    </th>
  }
  handleOnchange(id,num,times,index){
    let submit = {}
    let display = {}
    const { windowId } = this.props;
    const __methods = this.props.__METHOD.toJS();
    let selectValue = document.getElementById("selectValue" + index).value;
    let rate;
    times = parseInt(times)
    if(selectValue=="元"){
      selectValue = 1;
      rate = 1;
      submit.money = _.round(2*num*rate*times, 3).toFixed(3)
      display.money = _.round(2*num*rate*times, 3).toFixed(3)
    }
    if(selectValue=="角"){
      selectValue = 2;
      rate = 0.1;
      submit.money = _.round(2*num*rate*times, 3).toFixed(3)
      display.money = _.round(2*num*rate*times, 3).toFixed(3)
    }
    if(selectValue=="分"){
      selectValue = 3;
      rate = 0.01;
      submit.money = _.round(2*num*rate*times, 3).toFixed(3)
      display.money = _.round(2*num*rate*times, 3).toFixed(3)
    }
    if(selectValue=="厘"){
      selectValue = 4;
      rate = 0.001;
      submit.money = _.round(2*num*rate*times, 3).toFixed(3)
      display.money = _.round(2*num*rate*times, 3).toFixed(3)
    }
    submit.mode = selectValue;
    submit.rate = rate;
    display.mode = document.getElementById("selectValue" + index).value;
    display.rate = rate
    this.props.$$LOTTERY.updateModeOrder(submit, display, windowId, id) 
  }
  handleChangeTimes(id, times, num, rate){
    const { windowId } = this.props;
    const __methods = this.props.__METHOD.toJS();
    const flag = this.props.__METHOD.toJS().windows[windowId].flag
    //单注基础金额
    let defaultMoney = flag == "xglhc"?1:2
    let submit = {}
    let display = {}
    submit.times  = times
    display.times = times
    submit.money = _.round(defaultMoney*num*rate*times, 3).toFixed(3)
    display.money =  _.round(defaultMoney*num*rate*times, 3).toFixed(3)
    this.props.$$LOTTERY.updateTimesOrder(submit, display, windowId, id)

  }

  render() {
    const { windowId } = this.props;
    const __window = this.props.__METHOD.toJS().windows[windowId];
    const __base = this.props.__BASE.toJS();

    return (
      <div className='lottery-ssc-orderarea-main relative'>
        {
          !__window ? <Loader /> :
            <div>
              <div className="addList">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <td width="100%">
                        <div className="lotteryList">
                          <table>
                            <thead>
                              <tr className="cleanall">
                                <th width="60%">玩法与投注号码</th>
                                {/*<th>模式</th>*/}
                                {/*<th>资金模式</th>*/}
                                <th width="10%">倍率</th>
                                <th width="10%">注数</th>
                                <th width="10%">金额</th>
                                <th width="10%">
                                  <a onClick={this.removeBet.bind(this, null)} className="deleteAll pointer">全删</a>
                                </th>
                              </tr>
                            </thead>
                            {
                            !window.isIE?
                            <ReactCSSTransitionGroup
                              transitionAppear={true}
                              transitionEnterTimeout={300}
                              transitionLeaveTimeout={300}
                              transitionAppearTimeout={300}
                              transitionName='fade'
                              component='tbody' >
                              {
                                __window ? _.chain(__window.display).orderBy('id', 'desc').value().map((item, index) => {
                                  return <tr key={index} className="lottery">
                                    {this.makeCodes.bind(this)(item.methodName, item.codes, item.id,item.mode)}
                                    {/*<td>{_.split(item.prize,'模式:',2)}</td>*/}
                                    {/*<td key={item.mode}>*/}
                                    {/*{this.props.params.lotteryFlag == "xglhc"?"元":*/}
                                      {/*<select onChange={this.handleOnchange.bind(this,item.id,item.num,item.times,index)} className="selectValue" id={"selectValue" + index} defaultValue={item.mode}>*/}
                                        {/*<option>元</option>*/}
                                        {/*<option>角</option>*/}
                                        {/*<option>分</option>*/}
                                        {/*<option>厘</option>*/}
                                      {/*</select>*/}
                                    {/*}*/}
                                    {/*</td>*/}
                                    <td>
                                      <ChangeTimes
                                        value = {parseInt(item.times)}
                                        id = {item.id}
                                        num = {item.num}
                                        rate = {item.rate||1}
                                        onChange = {this.handleChangeTimes}
                                        index = {index}
                                      />
                                    </td>
                                    <td>{item.num}注</td>
                                    <td className="blue">{_.round(item.money, 3).toFixed(3)}元</td>
                                    <td className="del">
                                      <a className="del" onClick={this.removeBet.bind(this, item.id)}></a>
                                    </td>
                                  </tr>
                                }) : null
                              }
                            </ReactCSSTransitionGroup>
                            :
                            <tbody>
                              {
                                __window ? _.chain(__window.display).orderBy('id', 'desc').value().map((item, index) => {
                                  return <tr key={index} className="lottery">
                                    {this.makeCodes.bind(this)(item.methodName, item.codes, item.id,item.mode)}
                                    {/*<td>{_.split(item.prize,'模式:',2)}</td>*/}
                                    {/*<td key={item.mode}>*/}
                                    {/*{this.props.params.lotteryFlag == "xglhc"?"元":*/}
                                      {/*<select onChange={this.handleOnchange.bind(this,item.id,item.num,item.times,index)} className="selectValue" id={"selectValue" + index} defaultValue={item.mode}>*/}
                                        {/*<option>元</option>*/}
                                        {/*<option>角</option>*/}
                                        {/*<option>分</option>*/}
                                        {/*<option>厘</option>*/}
                                      {/*</select>*/}
                                    {/*}*/}
                                    {/*</td>*/}
                                    <td>
                                      <ChangeTimes
                                        value = {parseInt(item.times)}
                                        id = {item.id}
                                        num = {item.num}
                                        rate = {item.rate||1}
                                        onChange = {this.handleChangeTimes}
                                        index = {index}
                                      />
                                    </td>
                                    <td>{item.num}注</td>
                                    <td className="blue">{_.round(item.money, 3).toFixed(3)}元</td>
                                    <td className="del">
                                      <a className="del" onClick={this.removeBet.bind(this, item.id)}></a>
                                    </td>
                                  </tr>
                                }) : null
                              }
                            </tbody>
                            }
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="orderNow">
                <div className="trace-issues clear">
                    <div className="trace-left">
                      {/*<div className="countdownBox">*/}
                        {/*<div className="time-icon"></div>*/}
                        {/*<TimeBox*/}
                        {/*className="smallTime" */}
                        {/*current={!this.error ? this.countdown : null} */}
                        {/*interval={!this.error ? this.interval : null}*/}
                        {/*soundFn={null}*/}
                        {/*stopSoundFn={null}*/}
                        {/*/>*/}

                      {/*</div>*/}

                      <div className={this.props.params.lotteryFlag === 'mmc'?"mmcSendChoose sendChoose":"sendChoose"}>
                          <a className={__window.display.length == 0 ? 'disabled' : 'pointer'}
                             onClick={this.props.submit.bind(this, false)} >立即投注</a>
                      </div>
                      {
                        (_.includes(CANNOT_TRACK_LOTTERY, this.props.params.lotteryFlag) || !__window.track_issue) ?
                          null :
                          <div className="traceIssuesBox clear">
                            <div className="checkZhui fqzhBox" onClick={this.props.openTrack}>
                              <span className={_.size(__window.trace.lt_trace_issues) === 0 ? 'uncheck' : 'check'}></span>
                              <b className="fq">我要追号</b>
                            </div>
                            {/*<div className="checkZhui qxzhBox" onClick={this.props.$$LOTTERY.resetTrackInfo.bind(this, windowId)}>取消</div>*/}
                          </div>
                      }
                    </div>
                    

                </div>
                {
                  // 秒秒彩连续开奖
                  this.props.params.lotteryFlag === 'mmc' ?
                  <div className='mmc-box'>
                    <span className='text'>连开</span>
                    <SelectTimes
                      value={__window.times}
                      onChange={this.handleChangePlayTimes}
                      display = {__base.modal.overlay.display}
                    />
                    <span className='text'>期</span>
                  </div>:null
                }
                <div className="chooseAllMsg">
                  <p>已选 <span className="num">{__window.display.length} </span>单</p>
                  <p>共计 <span className="num">{_.sum(_.map(__window.display, 'num'))}</span> 注</p>
                  <p>金额 <span className="num orange">{_.round(_.size(__window.trace.lt_trace_issues) === 0 ? _.sum(_.map(__window.display, 'money')) * (__window.times || 1) : __window.trace.lt_trace_money, 3).toFixed(3)}</span> 元</p>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
        }
      </div>
    );
  }
}

reactMixin(OrderList.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __METHOD: state.method,
    __BASE: state.base
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderList)